export const DBConfig = (user: string) => {
    return {
        name: user,
        version: 1,
        objectStoresMeta: [
            {
                store: "draftPoll",
                storeConfig: { keyPath: "id", autoIncrement: true },
                storeSchema: [
                    {
                        name: "question",
                        keypath: "question",
                        options: { unique: false },
                    },
                    {
                        name: "draftChoices",
                        keypath: "draftChoices",
                        options: { unique: false },
                    },
                    {
                        name: "channel_id",
                        keypath: "channel_id",
                        options: { unique: false },
                    },
                    {
                        name: "public_media_url",
                        keypath: "public_media_url",
                        options: { unique: false },
                    },
                ],
            },
        ],
    };
};
